<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div v-html="html"></div>
</template>

<script setup lang="tsx">
import { defineProps } from 'vue';
import { useTable } from '../../../hooks/use-table';

const props = defineProps<{
  tableHeaderList: any;
  tableDataList: Array<{ [key: string]: Array<string> }>;
}>();

const className = 'chi-square-table-5';
const attrs = `border='0' bordercolor='#C0BEC7'`;
const { createTable } = useTable(props.tableHeaderList, className, attrs);
const html = createTable(props.tableDataList);
</script>
<style lang="scss">
@import '../../../styles/custom-table.scss';
.chi-square-table-5 {
  $height: 48px;
  $padding: 4px;
  $gap: 6pt;
  --header-cell-height: #{$height};
  --body-cell-height: #{$height};
  $border: 1pt solid #c0bec7;
  clip-path: polygon(
    $gap 0,
    calc(100% - #{$gap}) 0,
    calc(100% - #{$gap}) 100%,
    $gap 100%
  );
  thead {
    tr {
      th {
        padding: 0 $gap;
        background-color: var(--theme-color-1);
        div {
          color: #fff;
        }
      }
      &:first-child {
        th {
          background-color: #fff;
          & > div {
            color: #222;
            padding: 0 24px;
          }
        }
      }
      &:nth-child(2) {
        th[rowspan='1'] {
          div {
            border-bottom: 1pt solid #fff;
          }
        }
      }
    }
  }
  tbody {
    tr {
      td {
        padding-left: $gap;
        padding-right: $gap;
        & > div {
          font-size: 14px;
          border-left: $border;
          border-right: $border;
          background: var(--theme-color-1-10);
        }
        &:last-child {
          & > div {
            border-right: $border;
          }
        }
      }
      &:first-child,
      &:nth-last-child(2),
      &:has(td:nth-child(2).empty) {
        --body-cell-height: #{$height + $padding};
      }
      &:first-child {
        td {
          & > div {
            padding-top: $padding;
          }
        }
      }
      &:nth-last-child(2) {
        td {
          & > div {
            padding-bottom: $padding;
          }
        }
      }
      &:has(td:nth-child(2).empty) {
        td {
          & > div {
            padding-top: $padding;
          }
        }
      }
      .empty {
        & > div {
          border-bottom: none;
        }
      }
      &:has(td:nth-child(2).empty) {
        padding: 0 $gap;
        border-top: 2pt solid var(--theme-color-1);
        border-bottom: 2pt solid var(--theme-color-1);

        td {
          & > div {
            // border-left: none;
            // border-right: none;
            background: none;
          }
          &:not(:first-child) {
            div {
              border-left: none;
            }
          }
          &:not(:last-child) {
            div {
              border-right: none;
            }
          }
        }
      }
    }
  }
}
</style>
